import { Button as BaseButton } from '@base-ui/react/button';
import { clsx } from 'clsx';
import { type ReactNode } from 'react';
import {
  buttonV2,
  buttonV2EndIcon,
  buttonV2Sizes,
  buttonV2StartIcon,
  buttonV2Variants,
  type ButtonV2Size,
  type ButtonV2Variant,
} from './button-v2.css.ts';

export type { ButtonV2Size, ButtonV2Variant };

export type ButtonV2Props = Omit<BaseButton.Props, 'className'> & {
  variant?: ButtonV2Variant;
  size?: ButtonV2Size;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  className?: string;
};

export const ButtonV2 = ({
  variant = 'primary',
  size = 'default',
  startIcon,
  endIcon,
  className,
  children,
  ...rest
}: ButtonV2Props) => (
  <BaseButton
    className={clsx(
      buttonV2,
      buttonV2Variants[variant],
      buttonV2Sizes[size],
      size === 'default' && startIcon && buttonV2StartIcon,
      size === 'default' && endIcon && buttonV2EndIcon,
      className,
    )}
    {...rest}
  >
    {startIcon}
    {children}
    {endIcon}
  </BaseButton>
);
